<div class="loading d-flex w-100 h-100">
  <div class="w-100 text-center align-self-center display-1">
    <figure aria-live="polite">
      <img src="assets/gifs/load-start.gif" alt="" />
      <figcaption class="sr-only">loading in progress</figcaption>
    </figure>
  </div>
</div>
